module.exports = __webpack_public_path__ + "static/media/engineering_is_awesome.fe4c2c34.jpg";